var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isLoading)?_c('div',{staticClass:"item"},[_c('span',{staticClass:"button",on:{"click":function($event){return _vm.removeToFavorite()}}},[_c('span',{staticClass:"icon fastic-heart-full"}),_vm._v(_vm._s(_vm.localizer.get("App.Common.RemoveToFavorite")))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }